import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { B2bService } from 'src/service/b2b.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, KeyValues10, KeyValues5, LocalService, NumericConfig, Status } from 'src/service/local.service';

@Component({
  selector: 'app-b2b-owner',
  templateUrl: './b2b-owner.component.html',
  styleUrl: './b2b-owner.component.scss'
})
export class B2bOwnerComponent {
  @ViewChild('content_b2b_owner')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["b2b"];
  @Input() b2bAccountId: string = ''; data: KeyValues10;

  htmlId: string = ''; elementIds: any;
  numericConfig: NumericConfig = { isDecimalAllowed: false } as NumericConfig;
  contactNumber: null;

  items: KeyValues5[] = [];

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, private b2bService: B2bService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      add: 'btn_add' + this.htmlId,
      contact_nbr: 'txt_contact_number' + this.htmlId
    }
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onReset() {
    this.contactNumber = null;
    this.localService.onFocusNextInput(this.elementIds.contact_nbr, FocusInputType.Button, true, true);
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.onReset();
    this.b2bService.getB2bOwners(this.b2bAccountId, true).subscribe(result => {
      this.items = result;
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onSave();
      } break;
    }
  }

  onSave() {
    this.b2bService.saveB2bOwner(this.b2bAccountId, this.contactNumber).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }
}
